import type { GetEligibleCampaignsResponseType } from "@jti/rest-api-types";

export type LoyaltyDiscountState = "anonymous" | "logged-in-no-discount" | "logged-in-partial-discount";

export const getHighestEligibleCampaign = (
  campaigns: GetEligibleCampaignsResponseType[]
): GetEligibleCampaignsResponseType | null => {
  const eligibleCampaigns = campaigns.filter((campaign) => campaign.is_eligible);

  if (!eligibleCampaigns.length) {
    return null;
  }
  return eligibleCampaigns.reduce((highest, current) => {
    if (current.price > highest.price) {
      return current;
    }

    if (current.price === highest.price && current.points > highest.points) {
      return current;
    }

    return highest;
  });
};

export const resolveLoyaltyDiscountState = (
  isLoggedIn: boolean,
  campaigns: GetEligibleCampaignsResponseType[]
): LoyaltyDiscountState => {
  if (!isLoggedIn) {
    return "anonymous";
  }

  return getHighestEligibleCampaign(campaigns) ? "logged-in-partial-discount" : "logged-in-no-discount";
};
